import { render, staticRenderFns } from "./BiChart.vue?vue&type=template&id=710164ea&"
import script from "./BiChart.vue?vue&type=script&lang=js&"
export * from "./BiChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports